import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

const AboutInstructor = () => {
  const { course } = useStaticData()
  const { t } = useTranslation('@mc/next')

  return (
    <section className='mc-py-10' id='class-info'>
      <h2 className='mc-text-h4'>{t('lesson.details.about.title')}</h2>
      <p className='mc-text--muted mc-pt-4'>{course.marketingOverview}</p>
    </section>
  )
}

export default AboutInstructor
